// extracted by mini-css-extract-plugin
export default {"current_user":"InitialsCircleComponent_current_user__711dy"};